<template>
  <div>
    <div class="offcanvas offcanvas-start" style="width:65%" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
        <div class="offcanvas-header" :style="skin.side_bar.header + skin.side_bar.header_text" style="display: none;">
            <button id="closeSideBar" type="button" class="btn text-reset" data-bs-dismiss="offcanvas" aria-label="Close">
                <span style="color:white;font-size:large"><i class="fas fa-times"></i></span>
            </button>
        </div>
        <div class="offcanvas-body p-0" :style="skin.side_bar.body">
            <div
                class="p-3"
            >
                <div v-if="skin.front_lobby.enabled" @click="change_view('lobby')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/home.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Lobby</span>
                    </div>
                </div>
                <div v-else @click="change_view('main')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/home.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Inicio</span>
                    </div>
                </div>
                <div @click="change_view('main')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/sports.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Deportes</span>
                    </div>
                </div>
                <div v-if="skin.casinoN" @click="change_view('casino')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/casino.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Slots</span>
                    </div>
                </div>
                <div v-if="skin.casino_live" @click="change_view('casino_live')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/livecasino.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Casino Vivo</span>
                    </div>
                </div>
                <div v-if="skin.hipicas" @click="change_view('hipicas')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/horses.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Caballos</span>
                    </div>
                </div>
                <div v-if="skin.poker" @click="change_view('poker')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/poker.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Poker</span>
                    </div>
                </div>
                <div v-if="skin.bingo" @click="change_view('bingo')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/bingo.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">Bingo</span>
                    </div>
                </div>
                <div v-if="skin.crazzywin" @click="change_view('crazzyWin')" class="p-2">
                    <div class="d-flex">
                        <img src="https://resources.jbets.online/frontJM/icons/crazzy_win.png" class="me-1" style="width:36px;height:36px">
                        &nbsp;&nbsp;<span :style="skin.side_bar.navigation_text">CrazzyWin</span>
                    </div>
                </div>
                <!-- <div @click="terms" class="p-2">
                    <span><i class="far fa-list-alt me-1"></i>Términos y condiciones</span>
                </div> -->
                <!-- <language-selector
                    v-bind:skin="skin"
                    v-bind:language="language"
                /> -->
            </div>
        </div>  
    </div>
  </div>
</template>

<script>
import mainSearch from '../main_data/main_search.vue';
import eventoDeporteLive from './live/Evento_deporte_live.vue';
import timeLine from './prematch1/Time_line_prematch.vue';
import mainLigas from '../main_data/main_ligas.vue';
import mainLigas2 from '../main_data/main_ligas2.vue';
import eventoDeportePrematch from '../main_menu/prematch2/Evento_deporte_prematch2.vue';
import languageSelector from '../../header/language';
export default {
    name: 'Sidebar',
    components: {
        eventoDeporteLive,
        timeLine,
        mainSearch,
        mainLigas,
        mainLigas2,
        eventoDeportePrematch,
        languageSelector
    },
    props:['translation','language'],
    data(){
        return {
        booking_code:'',
        }
    },
    computed:{
        favoritos(){
            return this.$store.getters['live/getFavorites']; 
        },
        sports(){
           return this.$store.getters['live/getSports'];
        },
        skin(){
            return this.$store.getters['getCurrentSkin'];
        },
        user(){
            return this.$store.getters['getUserData'];
        },
        prematchTarget(){
            return this.$store.getters['getPrematchTarget'];
        },
        time2(){
            return this.$store.getters['prematch_2/getTime'];
        },
        timeLoading(){
            return this.$store.getters['prematch_2/getTimeLoading'];
        },
        sports_prematch(){
            return  this.$store.getters['prematch_2/getSports'];
        },
        nav_activeCss(){
            return {
            '--bar':this.skin.side_bar.nav_active_bar,
            '--text':this.skin.side_bar.nav_active_text,
            }
        },
        config(){
            return this.$store.getters['getConfig'];
        },
    },
    methods:{
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
        active: function (id) {
            let items = document.getElementsByClassName("item-menu");
            [...items].forEach(item=>{
                item.classList.remove('nav_active1');
                item.classList.remove('active');
            });
            document.getElementById(id).classList.add('nav_active1');
            document.getElementById(id).classList.add('active');
        },
        check_booking(){
            if(this.booking_code!=''){
                this.$store.dispatch('getBooking',this.booking_code);
            }
            else{
                this.alert.message=this.translate('valid_reservation_code');
                this.alert.type='danger';
                this.alert.active=true;
                setTimeout(this.alert_off,5000);
            }
        },
        change_view(view){
            document.getElementById('closeSideBar').click();
            if((view == "casino_live" || view == "casino" || view == "hipicas" || view == "bingo" || view == "poker" || view == "crazzyWin")&& this.user.token == ''){
                document.getElementById('login_btn').click();
            }
            else{
                if(view == "casino_live"){
                    window.postMessage({view: 'casino_live'},'*');
                }
                else if(view == "hipicas"){
                    window.postMessage({view: 'hipicas'},'*');
                }
                else{
                    this.$store.dispatch('setLobbyView',view);
                    this.$store.dispatch('setView',view);
                }
            }
        },
        terms(){
            let url = "";
            let lang = this.$props.language=='es'?'spa':(this.$props.language=='en'?'eng':(this.$props.language=='pt'?'pt-br':'spa'));
            if(this.user.prefix=="external"){
                url = "https://docs.betsw3.xyz/terms/"+lang+"/?site="+this.user.site.toUpperCase()+"&link="+this.user.site;
            }
            else{
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1]+'.'+domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/"+lang+"/?site="+domain_name1+"&link="+domain_name2;
            }
            
            window.open(url, '_blank').focus();
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-group2 {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
}
.nav_active1{
  color:var(--text);
  border-bottom:var(--bar);
}
</style>
